import {
  LOADING_PLANES,
  SET_ID,
  SET_PLANES,
  SET_DATA_GRUPO,
  SET_GRUPO_PLANES,
  FETCH_GRUPO_BYID,
  FETCH_GRUPO_PLANES,
  SET_DATA_GRUPO_COPY,
  FETCH_PLANES_BYPARAMS,
  FETCH_GRUPO_PLANES_BYID,
  SET_PLANES_DESDE_BUSQUEDA
} from './types';
import {
  getGrupoById,
  getGrupoPlanes,
  getGrupoPlanesById,
  getPlanesPorParametros
} from '../api/axios';

export const setPlanesDesdeBusqueda = (params) => async dispatch => {
  dispatch({
    type: SET_PLANES_DESDE_BUSQUEDA,
    payload: params,
  });
}

export const setPlanes = (params) => async dispatch => {
  dispatch({
    type: SET_PLANES,
    payload: params,
  });
}

export const setGrupoPlanes = (params) => async dispatch => {
  dispatch({
    type: SET_GRUPO_PLANES,
    payload: params,
  });
}

export const setId = (params) => async dispatch => {
  dispatch({
    type: SET_ID,
    payload: params,
  });
}

export const fetchGrupoPlanes = (request) => async dispatch => {
  dispatch({
    type: LOADING_PLANES,
    payload: true
  });

  let array = getGrupoPlanes(request.params);
  array.then((value) => {
    dispatch({
      type: FETCH_GRUPO_PLANES,
      payload: value
    });
    dispatch({
      type: LOADING_PLANES,
      payload: false
    });
  })
}

export const fetchGrupoPlanesById = (id) => async dispatch => {
  dispatch({
    type: LOADING_PLANES,
    payload: true
  });

  if (id === 0) {
    dispatch({
      type: FETCH_GRUPO_PLANES_BYID,
      payload: { data: { elementos: [] } }
    });
    dispatch({
      type: LOADING_PLANES,
      payload: false
    });
  } else {
    let array = getGrupoPlanesById(id);
    array.then((value) => {
      dispatch({
        type: FETCH_GRUPO_PLANES_BYID,
        payload: value
      });
      dispatch({
        type: LOADING_PLANES,
        payload: false
      });
    })
  }
}

export const fetchGrupo = (id) => async dispatch => {
  let array = getGrupoById(id);
  array.then((value) => {
    dispatch({
      type: FETCH_GRUPO_BYID,
      payload: value
    });
  })
}

export const setDataGrupo = (params) => async dispatch => {
  dispatch({
    type: SET_DATA_GRUPO,
    payload: params,
  });
}

export const setDataGrupoCopy = (params) => async dispatch => {
  dispatch({
    type: SET_DATA_GRUPO_COPY,
    payload: params
  });
}

export const fetchPlanesPorParametros = (params) => async dispatch => {
  let array = getPlanesPorParametros(params);
  array.then((value) => {

    dispatch({
      type: FETCH_PLANES_BYPARAMS,
      payload: value.data
    });
  })
}